<template>
 <el-dialog title='角色授权'  width="65%" top="5vh" :append-to-body="true" :visible.sync="isShow.show">
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               @tree-load="treeLoad"
               ref="crud"
               v-model="form"
               @search-change="searchChange"
               @search-reset="searchReset"
                @selection-change="selectionChange"
               >
     <template v-slot:subjectStatus="{row,label}" >
       <el-tag v-if="label === '可用'" type="success" size="small" >可用</el-tag>
       <el-tag v-else-if="label === '停用'" type="info" size="small">停用</el-tag>
       <el-tag v-else type="danger" size="small">未知</el-tag>
    </template>
    <!-- 操作按钮扩展 -->
    <template v-slot:menu="{row}" >
       <el-switch @change="changeAuth(row)"  v-model="row.__auth_status__" ></el-switch>
    </template>
    <!-- 操作按钮扩展 -->
    <template v-slot:menuLeft="{}" >
      <el-row >
        <el-col  :span="24">
          <el-select   v-model="concatPattern"  style="width:100%"  size="mini" placeholder="请选择搜索模式">
              <el-option label="向上级联模式" :value="1"></el-option>
              <el-option label="向下级联模式" :value="2"></el-option>
              <el-option label="上下级联模式" :value="3"></el-option>
              <el-option label="非级联模式" :value="4"></el-option>
          </el-select>
        </el-col >
      </el-row>
    </template>
    </avue-crud>

  </basic-container>
  </el-dialog>
</template>

<script>
import { optionConfig } from '@/framework/util/optionConfig'
export default {
  components: { },
  props: ['isShow', 'optionRow', 'type'],
  data() {
    return {
      concatPattern: 2,
      pageControl: {
        subjectType: null
      },
      loading: false,
      form: {},
      query: {},
      selectionList: [],
      option: {
        height: '500',
        lazy: true,
        rowKey: 'treeId',
        refreshBtn: false,
        searchBtn: true,
        columnBtn: false,
        tip: false,
        tree: true,
        border: false,
        selection: true,
        addBtn: false,
        editBtn: false,
        searchMenuSpan: 6,
        delBtn: false,
        viewBtn: false,

        column: [
          {
            prop: 'appKey',
            label: '所属应用',
            search: true,
            hide: true,
            type: 'select',
            span: 12,
            dicData: [],
            rules: [{
              required: true,
              message: '请选择所属应用',
              trigger: 'blur'
            }]
          },
          {
            label: '权限名称·',
            prop: 'subjectName',
            search: true,
            overHidden: true,
            rules: [{
              required: true,
              message: '请输入权限名称',
              trigger: 'blur'
            }]
          },
          {
            label: '权限标识',
            prop: 'unifiedId',
            search: true,
            rules: [{
              required: true,
              message: '请输入权限标识',
              trigger: 'blur'
            }]
          },
          {
            label: '状态',
            prop: 'subjectStatus',
            type: 'select',
            search: true,
            slot: true,
            align: 'center',
            width: '100px',
            dicData: [
              {
                label: '可用',
                value: 1
              },
              {
                label: '停用',
                value: 2
              }
            ],
            rules: [{
              required: true,
              message: '请选择机构状态',
              trigger: 'blur'
            }]
          }, {
            label: '扩展字段',
            prop: 'subjectExtList',
            type: 'dynamic',
            span: 24,
            hide: true,
            'children': {
              'align': 'center',
              'headerAlign': 'center',
              'column': [
                {
                  'type': 'input',
                  'label': '字段名',
                  'span': 24,
                  'prop': 'extPropertyKey'
                },
                {
                  'type': 'input',
                  'label': '字段值',
                  'span': 24,
                  'prop': 'extPropertyValue'
                },
                {
                  'type': 'input',
                  'label': '字段描述',
                  'span': 24,
                  'prop': 'description'
                }
              ]
            }
          }
        ]
      },
      data: []

    }
  },
  created() {
    this.pageControl.subjectType = 'RESOURCE_GROUP'
  },
  mounted() {
    this.option = optionConfig(this.option)
  },
  methods: {
    /** Initialization table */
    Initialize: function(params) {
      this.concatPattern = 2
      this.data = []
      this.query = {}
      /** 这里执行其他操作 */
      this.$nextTick(() => {
        this.getSelectOPtion()
      })
    },

    selectionChange(list) {
      this.selectionList = list
    },
    /** 搜索重置 */
    searchReset() {
      this.query = {}
    },
    /** 点击搜索 */
    searchChange(params, done) {
      if (!params.appKey) {
        this.$message.error('您必须选择一个所属应用后再进行查询。')
        typeof done === 'function' && done()
      } else {
        this.query = params
        if (params.unifiedId || params.subjectStatus || params.subjectName) {
          this.searchTable(done)
        } else {
          this.loadTable(params, done)
        }
      }
    },
    /** 加载所属应用 */
    getSelectOPtion() {
      this.$http.post('/resource/list-authorized-resource', { entity: {
        'obj': 'Permission.App',
        'appKey': '@PUBLIC'
      }},
      { params: { isRecursive: true, recursiveWithCondition: true, recursiveIgnoreProperties: ['obj'], onlyChild: true }}).then(response => {
        let result = response.data.map(element => {
          let temp = {}
          element.resourceExtList.forEach(item => {
            if (item.extPropertyKey === 'appName') {
              temp.label = item.extPropertyValue
            } else if (item.extPropertyKey === 'appKey') {
              temp.value = item.extPropertyValue
            }
          })
          return temp
        })
        if (result.length !== 0) {
          this.option.column[this.findArray(this.option.column, 'appKey', 'prop')].dicData = result
          try {
            this.$refs.crud.searchForm.appKey = this.query.appKey = result[0].value
            this.searchChange(this.query)
            /** 加载第一层资源 */
          } catch (e) {
            this.$message.error('默认填充appKey失败。')
          }
        }
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    searchTable: function(done) {
      /** 下级节点 */
      this.loading = true
      this.$http.post('/permission/subject/private/common/list', {
        entity: {
          appKey: this.query.appKey,
          subjectType: this.pageControl.subjectType,
          subjectName: this.query.subjectName ? this.query.subjectName : null,
          unifiedId: this.query.unifiedId ? this.query.unifiedId : null,
          subjectStatus: this.query.subjectStatus ? this.query.subjectStatus : null
        }
      }, { params: {
        searchType: 'NOT_APP',
        childSubjectIdList: this.optionRow.permissionSubjectId
      }}).then(response => {
        typeof done === 'function' && done()
        this.loading = false
        this.data = response.data.map(element => {
          if (element.childPolicyGroupMap && element.childPolicyGroupMap.length >= 1) {
            element.__auth_status__ = true
          } else {
            element.__auth_status__ = false
          }
          return element
        })
      }).catch(error => {
        typeof done === 'function' && done()
        this.data = []
        this.loading = false
        this.$message.error(error.msg)
      })
    },
    loadTable(params = this.query, done) {
      this.loading = true
      this.$http.post('/permission/subject/top-subject', undefined, {
        params: {
          appKey: params.appKey,
          'subjectTypeEnum': this.pageControl.subjectType,
          childSubjectIdList: this.optionRow.permissionSubjectId
        }
      }).then(response => {
        this.loading = false
        typeof done === 'function' && done()
        this.data = response.data.map(element => {
          element.hasChildren = true
          element.treeId = element.id
          if (element.childPolicyGroupMap && element.childPolicyGroupMap.length >= 1) {
            element.__auth_status__ = true
          } else {
            element.__auth_status__ = false
          }
          return element
        })
      }).catch(error => {
        typeof done === 'function' && done()
        this.loading = false
        this.$message.error(error.msg)
      })
    },
    treeLoad(tree, treeNode, resolve) {
      /** 下级节点 */
      this.$http.post('/permission/subject/private/common/list', {
        entity: {
          appKey: this.query.appKey,
          'subjectType': this.pageControl.subjectType
        }
      }, { params: {
        searchType: 'NOT_APP',
        parentSubjectIdList: tree.id,
        unionParentSubjectType: 'IN',
        childSubjectIdList: this.optionRow.permissionSubjectId
      }}).then(response => {
        treeNode.childNodes = []
        return resolve(response.data.map(element => {
          element.$parent = tree
          if (!element.$parent.$children) {
            element.$parent.$children = []
          }
          element.$parent.$children.push(element)
          element.hasChildren = true
          element.treeId = tree.id + element.id
          if (element.childPolicyGroupMap && element.childPolicyGroupMap.length >= 1) {
            element.__auth_status__ = true
          } else {
            element.__auth_status__ = false
          }
          return element
        }))
      }).catch(error => {
        treeNode.childNodes = []
        resolve([])
        this.$message.error(error.msg)
      })
    },
    changeAuth: function(row) {
      this.loading = true
      let postUrl = row.__auth_status__ ? '/permission/subject/group/policy' : '/permission/subject/group/policy/del'
      let cancatP = this.getcancatPattern()
      let params = {
        'appKey': row.appKey,
        'parentSubjectId': row.id,
        subjectId: this.optionRow.permissionSubjectId
      }
      if (cancatP) {
        params['parentRecursiveType'] = cancatP
      }
      this.$http.post(postUrl, {
        'relation': 'RESOURCE_GROUP2RESOURCE_GROUP'
      }, { params }).then(response => {
        this.loading = false
        this.$message.success('操作成功')
        /** 这里手动执行递归操作 */
        if (cancatP === 'up') { // 向上级联
          this.toolRecursiveUpward(row, row.__auth_status__)
        } else if (cancatP === 'down') { // 向下级联
          this.toolRecursiveDown(row, row.__auth_status__)
        } else if (cancatP === 'all') { // 上下级联
          this.toolRecursiveUpward(row, row.__auth_status__)
          this.toolRecursiveDown(row, row.__auth_status__)
        }
        // 非级联模式 不进行任何操作
        // this.searchChange(this.query)
      }).catch(error => {
        this.loading = false
        this.$message.error(error.msg)
        row.__auth_status__ = !row.__auth_status__
      })
    },
    // 递归向上
    toolRecursiveUpward(row, __auth_status__value) {
      if (row.$parent) {
        row.$parent.__auth_status__ = __auth_status__value
        this.toolRecursiveUpward(row.$parent, __auth_status__value)
      }
    },
    // 递归向下
    toolRecursiveDown(row, __auth_status__value) {
      if (Array.isArray(row.$children) && row.$children.length) {
        row.$children.forEach(item => {
          item.__auth_status__ = __auth_status__value
          this.toolRecursiveDown(item, __auth_status__value)
        })
      }
    },
    getcancatPattern: function() {
      switch (this.concatPattern) {
        case 1: return 'up'
        case 2: return 'down'
        case 3: return 'all'
        case 4: return null
      }
    }

  }
}
</script>

<style>
</style>
